document.addEventListener('DOMContentLoaded', function () {
    const splideRelated = document.querySelector('.splideRelatedBlogs');

    if (splideRelated && typeof Splide !== 'undefined') {

        const relatedSplide = new Splide(splideRelated, {
            gap: 10,
            arrows: false,
            pagination: true,
            mediaQuery: 'min',
            classes: {
                pagination: 'splide__pagination position-relative bottom-0 d-flex justify-content-md-end justify-content-center mt-4 px-0',
                page: 'splide__pagination--page border-0 rounded-circle mx-1',
            },
            breakpoints: {
                576: {
                    perPage: 2,
                },
                992: {
                    perPage: 3,
                },
                1200: {
                    gap: 16,
                }
            }
        });

        relatedSplide.mount();
    }
});
